import { render } from "./ChevronDoubleRight.vue?vue&type=template&id=5025adb2"
import script from "./ChevronDoubleRight.vue?vue&type=script&lang=js"
export * from "./ChevronDoubleRight.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5025adb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5025adb2', script)) {
    api.reload('5025adb2', script)
  }
  
  module.hot.accept("./ChevronDoubleRight.vue?vue&type=template&id=5025adb2", () => {
    api.rerender('5025adb2', render)
  })

}

script.__file = "src/icons/components/filled/ChevronDoubleRight.vue"

export default script